import React from "react";
import VideoCaption from "./videoCaption";

export const VideoWithCaptions = (props) => {
  const { videoSource, videoPoster, part } = props;

  const vidRef = React.useRef(null);
  const [tick, setTick] = React.useState();

  React.useEffect(() => {
    const tickUpdateListener = () => {
      const temp = Math.floor(Number(vidRef?.current?.currentTime || 0));
      setTick(temp);
    };

    const current = vidRef.current;
    if (current) {
      current.addEventListener("timeupdate", tickUpdateListener);
    }

    return () => {
      if (current) {
        current.removeEventListener("timeupdate", tickUpdateListener);
      }
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ maxWidth: "720px", margin: "0 1rem" }}>
        <video
          poster={videoPoster.default}
          ref={vidRef}
          id="vid"
          style={{width: "100%"}}
          preload="metadata"
          controls
          playsInline
          muted
        >
          <source src={videoSource.default} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <VideoCaption currentTick={tick} braPart={part} />
      </div>
    </div>
  );
};

export default VideoWithCaptions;
